export function handleDemoFormOrBot () {
  const bookADemoButtons = document.querySelectorAll('[data-toggle=get-a-demo]');
  const resetScroll = document.getElementById('reset-scroll');
  resetScroll && resetScroll.classList.add('enterprise-page');

  bookADemoButtons.forEach(button => {
    button.addEventListener('pointerup', () => {
      const pageHasBot = !!document.getElementById('hubspot-messages-iframe-container');

      pageHasBot ? _handleBot() : _handleForm();
    });
  });
}

function _handleBot () {
  const isBotOpen = document.querySelector('.hs-shadow-container').classList.contains('active');
  const searchParams = new URLSearchParams(window.location.search);
  const hasBookADemo = searchParams.has('bookademo');

  !isBotOpen && hasBookADemo && window.HubSpotConversations.widget.open();

  if (!hasBookADemo) {
    window.history.pushState({}, 'bookademo', '?bookademo=true');
    window.HubSpotConversations.widget.refresh({ openToNewThread: true });

    // Hubspot not working as in its docs and this hack is needed for now.
    setTimeout(() => window.HubSpotConversations.widget.open(), 1500);
  }
}

function _handleForm () {
  const form = document.getElementById('contact-form');

  form && form.scrollIntoView({ behavior: 'smooth' });
}
